// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mediaRequestStatusEntity from './entities/media-request-status.json';
import mediaRequestStatusMenu from '../pages/media-request-status/menu.json';
import mediaRequestStatusFullForm from '../pages/media-request-status/forms/full.json';
import mediaRequestStatusContextForm from '../pages/media-request-status/forms/context.json';
import mediaRequestStatusMiniForm from '../pages/media-request-status/forms/mini.json';
import mediaRequestStatusLookupForm from '../pages/media-request-status/forms/lookup.json';
import mediaRequestStatusTableView from '../pages/media-request-status/views/table.json';
import mediaRequestStatusDashboardView from '../pages/media-request-status/views/dashboard.json';

/** Тип запису «Статус запиту медіа» зі сторінками пакета: меню, форми та подання з pages/media-request-status/. */
export const mediaRequestStatusDefinition: IRecordTypeDefinition = {
  ...mediaRequestStatusEntity,
  views: assembleViewSet({
      table: mediaRequestStatusTableView,
      dashboard: mediaRequestStatusDashboardView,
  }),
  form: mediaRequestStatusFullForm,
  forms: { full: mediaRequestStatusFullForm, context: mediaRequestStatusContextForm, mini: mediaRequestStatusMiniForm, lookup: mediaRequestStatusLookupForm },
  menu: mediaRequestStatusMenu,
} as IRecordTypeDefinition;
